import { createFileRoute } from "@tanstack/react-router"

import Catalog from "../../components/Catalog"

import { Box, Container, Flex } from "@chakra-ui/react"
import Cart from "../../components/Cart"
import Checkout from "../../components/Checkout"
import CheckoutButton from "../../components/CheckoutButton"

export const Route = createFileRoute("/_layout/shop")({
  component: Shop,
})

function Shop() {
  return (
    <>
      <Container maxW="full">
        <Box pt={12} m={4}>
          <Flex direction="column" align="flex-start">
            <Catalog />
            <Cart />
            <CheckoutButton />
            <Checkout />
          </Flex>
        </Box>
      </Container>
    </>
  )
}
